import { AppTabs } from 'shared/UI/UIKit/Tab';
import type { AppTableColumn } from 'shared/UI/UIKit/Table';
import type { EducationLevel } from 'services/api/types';
import type { SubjectWithDifficulty } from 'services/api/subject-difficulties';
import { SubjectDifficultiesTable } from '../../Table';
import { tabsConfig } from '../model';

interface TabsProps {
  selectedTab: EducationLevel;
  onSelectTab: (key: string) => void;
  subjects: SubjectWithDifficulty[];
  loading: boolean;
  columns: AppTableColumn<SubjectWithDifficulty>[];
}

export const Tabs = ({ selectedTab, onSelectTab, subjects, loading, columns }: TabsProps) => {
  return (
    <AppTabs onChange={onSelectTab} defaultActiveKey={selectedTab} activeKey={selectedTab}>
      {tabsConfig.map((tab) => (
        <AppTabs.TabPane key={tab.key} tab={tab.name}>
          <SubjectDifficultiesTable
            key={tab.key}
            columns={columns}
            subjects={subjects}
            loading={loading}
          />
        </AppTabs.TabPane>
      ))}
    </AppTabs>
  );
};
